import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, List, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import _ from "lodash";

import { useServerApi } from "../hooks/userServerApi";
import {
  EDD_INDICATOR_LABELS,
  activeEddIndicators,
  openEddTab,
} from "../helpers/eddIndicatorLabels";

const ClientEddAlert = ({ form }) => {
  const clientId = _.get(form.values, "_id");
  const [api] = useServerApi();
  const apiRef = useRef(api);
  apiRef.current = api;
  const { t } = useTranslation();
  const [indicators, setIndicators] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!clientId) {
        setIndicators([]);
        return;
      }
      const result = await apiRef.current.Client.getOrderSummary(clientId);
      if (cancelled) return;
      setIndicators(
        result?.success ? activeEddIndicators(result.data) : []
      );
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [clientId]);

  if (!indicators.length) return null;

  return (
    <Alert
      icon={<IconAlertTriangle size={16} />}
      color="orange"
      title={t("EDD indicator")}
      mb="sm"
    >
      <Text size="sm" mb="xs">
        {t("This client meets an enhanced due diligence check.")}
      </Text>
      <List size="sm" mb="sm">
        {indicators.map((key) => (
          <List.Item key={key}>{t(EDD_INDICATOR_LABELS[key])}</List.Item>
        ))}
      </List>
      <Button size="xs" variant="light" color="orange" onClick={openEddTab}>
        {t("View EDD")}
      </Button>
    </Alert>
  );
};

export default ClientEddAlert;
